import Skeleton, { SkeletonOwnProps } from '@mui/material/Skeleton';
import { missingValuePlaceholder } from '@utils/constants';

interface ISkeletonColumnCell {
  height?: string;
  value: string;
  variant?: SkeletonOwnProps['variant'];
  width?: string;
}

export const SkeletonColumnCell = ({
  height,
  value,
  variant,
  width,
}: ISkeletonColumnCell) => {
  if (value === missingValuePlaceholder) {
    return (
      <Skeleton
        sx={{ height: height ?? '30px', width: width ?? 'inherit' }}
        variant={variant}
      />
    );
  }
  return <>{value}</>;
};
